import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { financialDashboardGuard } from './core/guards/financial-dashboard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () => import('./layout').then((m) => m.DefaultLayoutComponent),
    data: {
      title: 'Tablero Principal',
    },
    children: [
      {
        // Análisis Económico para quien tiene el permiso; el resto va al Tablero de Reservas.
        path: 'dashboard',
        canActivate: [financialDashboardGuard],
        loadComponent: () =>
          import('../app/ui/shared/base-layout/base-layout').then((m) => m.BaseLayoutComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../app/ui/components/financial-dashboard/financial-dashboard.component').then(
                (m) => m.FinancialDashboardComponent,
              ),
            data: {
              title: 'Análisis Económico',
            },
          },
        ],
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('../app/ui/components/client/routes/routes').then((m) => m.clientRoutes),
      },
      {
        path: 'staff',
        loadChildren: () =>
          import('../app/ui/components/staff/routes/routes').then((m) => m.staffRoutes),
      },
      {
        path: 'providers',
        loadChildren: () =>
          import('../app/ui/components/provider/routes/routes').then((m) => m.providerRoutes),
      },
      {
        path: 'packages',
        loadChildren: () =>
          import('../app/ui/components/tourist-plans/routes/routes').then(
            (m) => m.touristPlansRoutes,
          ),
      },
      {
        path: 'payment-gateways',
        loadChildren: () =>
          import('../app/ui/components/payment-gateways/routes').then(
            (m) => m.paymentGatewaysRoutes,
          ),
      },
      {
        path: 'parametrizacion',
        loadChildren: () =>
          import('../app/ui/components/tourist-plans/routes/parametrizacion.routes').then(
            (m) => m.parametrizacionRoutes,
          ),
      },
      {
        path: 'indicators',
        loadChildren: () =>
          import('../app/ui/components/management-indicators/routes').then(
            (m) => m.managementIndicatorsRoutes,
          ),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('../app/ui/components/super-admin/routes/routes').then((m) => m.superAdminRoutes),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./ui/pages/profile/profile.component').then((m) => m.ProfileComponent),
        data: {
          title: 'Mi Perfil',
        },
      },
      {
        path: 'my-quotes',
        loadComponent: () =>
          import('./ui/pages/my-quotes/my-quotes.component').then((m) => m.MyQuotesComponent),
        data: {
          title: 'Mis Cotizaciones',
        },
      },
    ],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./ui/pages/page404/page404.component').then((m) => m.Page404Component),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./ui/pages/page500/page500.component').then((m) => m.Page500Component),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    loadComponent: () => import('./ui/pages/login/login.component').then((m) => m.LoginComponent),
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./ui/pages/reset-password/reset-password').then((m) => m.ResetPasswordComponent),
    data: {
      title: 'Reset Password Page',
    },
  },
  {
    path: 'reset-password-request/:action',
    loadComponent: () =>
      import('./ui/pages/reset-password-request/reset-password-request.component').then(
        (m) => m.ResetPasswordRequestComponent,
      ),
    data: {
      title: 'Reset Password Request Page',
    },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./ui/pages/register/register.component').then((m) => m.RegisterComponent),
    data: {
      title: 'Register Page',
    },
  },
  {
    path: 'template',
    loadComponent: () =>
      import('./template/layout/default-layout/default-layout.component').then(
        (m) => m.DefaultLayoutComponentTemplate,
      ),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./template/views/dashboard/routes/routes').then((m) => m.routes),
      },
      {
        path: 'theme',
        loadChildren: () => import('./template/views/theme/routes').then((m) => m.routes),
      },
      {
        path: 'base',
        loadChildren: () => import('./template/views/base/routes').then((m) => m.routes),
      },
      {
        path: 'buttons',
        loadChildren: () => import('./template/views/buttons/routes').then((m) => m.routes),
      },
      {
        path: 'forms',
        loadChildren: () => import('./template/views/forms/routes').then((m) => m.routes),
      },
      {
        path: 'icons',
        loadChildren: () => import('./template/views/icons/routes').then((m) => m.routes),
      },
      {
        path: 'notifications',
        loadChildren: () => import('./template/views/notifications/routes').then((m) => m.routes),
      },
      {
        path: 'widgets',
        loadChildren: () => import('./template/views/widgets/routes').then((m) => m.routes),
      },
      {
        path: 'charts',
        loadChildren: () => import('./template/views/charts/routes').then((m) => m.routes),
      },
      {
        path: 'pages',
        loadChildren: () => import('./template/views/pages/routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./ui/pages/home/home-layout/home-layout').then((m) => m.HomeLayout),
    data: { title: 'Home Page' },
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./ui/pages/flights/flights-results/flights-results').then((m) => m.FlightsResults),
    data: { title: 'Resultados de Búsqueda' },
  },
  {
    path: 'flights',
    redirectTo: 'search',
    pathMatch: 'full',
  },
  {
    path: 'hotels/:despegarId',
    loadComponent: () => import('./ui/pages/hotel-detail/hotel-detail').then((m) => m.HotelDetail),
    data: { title: 'Detalle del Hotel' },
  },
  {
    path: 'tours/:id',
    loadComponent: () => import('./ui/pages/tour-detail/tour-detail').then((m) => m.TourDetail),
    data: { title: 'Detalle del Tour' },
  },
  {
    path: 'transfers/:id',
    loadComponent: () =>
      import('./ui/pages/transfer-detail/transfer-detail').then((m) => m.TransferDetail),
    data: { title: 'Detalle del Traslado' },
  },
  {
    path: 'seguros/:id',
    loadComponent: () =>
      import('./ui/pages/insurance-detail/insurance-detail').then((m) => m.InsuranceDetail),
    data: { title: 'Detalle del Seguro' },
  },
  {
    path: 'flights/:itineraryId',
    loadComponent: () =>
      import('./ui/pages/flight-detail/flight-detail').then((m) => m.FlightDetail),
    data: { title: 'Detalle del Vuelo' },
  },
  {
    path: 'checkout',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./ui/pages/checkout/checkout.component').then((m) => m.CheckoutComponent),
    data: { title: 'Finalizar Reserva' },
  },
  {
    path: 'checkout/result',
    loadComponent: () =>
      import('./ui/pages/checkout/checkout-result/checkout-result.component').then(
        (m) => m.CheckoutResultComponent,
      ),
    data: { title: 'Resultado del Pago' },
  },
  {
    path: 'packages/own-tourist-packages/:id',
    loadComponent: () =>
      import('./ui/pages/own-package-detail/own-package-detail').then((m) => m.OwnPackageDetail),
    data: { title: 'Detalle del Paquete' },
  },
  { path: '**', redirectTo: '404' },
];
